/*
 * @Descripttion: 
 * @version: 
 * @Author: wangz
 * @Date: 2019-11-21 14:58:04
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-02 14:22:33
 */
/*   参数工厂
 --------------------------------------------------------------------------------
 作者：王哲                           创建日期：2018/03/12
 --------------------------------------------------------------------------------
 提供方法列表：
 ★对象保存
 ★对象读取
 ★根据参数guid创建对象
 ★对象删除
 --------------------------------------------------------------------------------
 修改：                               修改日期：
 修改内容:

 --------------------------------------------------------------------------------

 *******************************************************************************/

import { GUID } from '../sgiConstants/sgiCommonConstant'
import * as sgiCommon from '../sgiCommon/sgiCommon'
import { sgiLocalStorage } from '../sgiCommon/localStorage'
import { sgiPfClient } from '../sgiCommon/sgiClient'
import sgiConfig from '../sgiConfig/sgiConfig'
import smProjDndConfig from '../sgiConfig/smProjDndConfig'
import { SAPrmFactory } from './SAPrmFactory'
import { sgiLogger } from "../sgiCommon/sgiLogger";

const cacheFlag = false;

/**
 * 去掉参数中的特定无用字段，默认去掉_key字段
 * @param {*} obj 
 * @param {*} keyCode 
 * @author hanzb 2018年11月13日
 * @private
 */
const _keyFilter = function (obj, keyCode) {
	if (!obj) return;
	keyCode = keyCode || "_key";
	delete obj[keyCode];
	let cldSet = obj.cldSet;
	if (cldSet && cldSet.length > 0) {
		cldSet.forEach(cld => {
			delete cld[keyCode];
			_keyFilter(cld, keyCode);
		});
	}
}

/**
 * 参数工厂操作方法
 * @namespace 参数工厂方法集
 */
let PrmFactory = {
	/**
	 * 
	 * @param {*} pageInfo 
	 * @param {*} callback 
	 * @ignore
	 */
	batchPrm: function (pageInfo, callback) {
		this.getPrmBySS();
	},
	/**
	 * 获取参数
	 *  @param {string} guid 参数唯一key
	 *  @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	 *  @return {object} 返回参数
	 */
	getPrm: function (guid, fromserver) {

		if (smProjDndConfig.isSAPrm(guid)) {
			return SAPrmFactory.getPrm(guid);
		}

		if (!guid) {
			return null;
		}
		if (typeof guid != 'string' || guid.constructor != String) {
			return null;
		}
		var ms = guid.split("`");
		var mguid = ms[0];
		var strJson = null;
		if (!fromserver && cacheFlag) {
			strJson = this.getPrmCache(mguid);
		}
		var json = {};
		if (!strJson) {
			if (sgiConfig.prmRelease) {
				strJson = sgiPfClient.restcall(sgiConfig.pf + "/prmFirst/" + guid, "GET");
			} else {
				strJson = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + guid, "GET");
			}
			if (strJson) {
				switch (sgiCommon.getType(strJson)) {
					case "string": json = sgiCommon.strToJson(strJson); break;
					case "object":
						if (strJson.body) {
							strJson = strJson.body;
							json = sgiCommon.getType(strJson) === "string" ? sgiCommon.strToJson(strJson) : strJson;
						}
						break;
					default:
						break;
				}
			}
			// if (strJson && typeof strJson != "object") {
			// 	json = sgiCommon.strToJson(strJson);
			// }
		} else {
			json = sgiCommon.strToJson(strJson);
		}
		if (!json) {
			return null;
		}
		var length = ms.length;
		for (var i = 1; i < length; i++) {
			json = this.findMenber(json, ms[i]);
		}
		return json;
	},
	/**
	 * 获取发布参数
	 * @param {string} guid 参数唯一key
	 * @param {boolean} [fromserver=false]	(暂不可用)强制从服务端获取参数标志，true表示强制从服务端获取
	 * @return {object} 返回参数
	 * 
	 * @ignore
	 */
	getPrmPublish: function (guid, fromserver) {
		if (!guid) {
			return null;
		}
		if (typeof guid != 'string' || guid.constructor != String) {
			return null;
		}
		var ms = guid.split("`");
		var mguid = ms[0];
		var strJson = null;
		if (!fromserver && cacheFlag) {
			strJson = this.getPrmCache(mguid);
		}
		var json = {};
		if (!strJson) {
			strJson = sgiPfClient.restcall(sgiConfig.pf + "/getPublish/" + guid, "GET");
			if (strJson && typeof strJson != "object") {
				json = sgiCommon.strToJson(strJson);
			}
		} else {
			json = sgiCommon.strToJson(strJson);
		}
		if (!json) {
			return null;
		}
		var length = ms.length;
		for (var i = 1; i < length; i++) {
			json = this.findMenber(json, ms[i]);
		}
		return json;
	},
	/**
	 * 保存参数方法
	 *  @param {object} root 需要保存的参数对象
	 *  @return {number} 0-成功，-1-失败
	 */
	save: function (root) {
		if (!root) {
			return -1;
		}

		if (!root && typeof root !== "object") {
			return -1;
		}

		if (smProjDndConfig.isSAPrmByAP(root.ap)) {
			root.nam = root.te || root.n;
			let saResult = SAPrmFactory.save(root)
			return saResult ? 0 : -1;
		}

		var guid = this.makeGUID(root);
		root.guid = guid;//参数赋值/重写guid  hanzb 2018-5-11

		var data = {};
		let copyRoot = tool.copy(root, true);
		// 去掉_key属性
		_keyFilter(copyRoot);
		data.root = sgiCommon.jsonToStr(copyRoot);
		var result = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + guid, "PUT", data);

		if (result === 0) {
			var newprm = this.getPrm(guid, true);
			root.prmVsn = newprm.prmVsn;
			root.auth = newprm.auth;
			root.crtTm = newprm.crtTm;
			root.edAuth = newprm.edAuth;
			root.edTm = newprm.edTm;
			root.prmT = newprm.prmT;

			if (cacheFlag) {
				this.saveLocal(guid, sgiCommon.jsonToStr(root));//json
			}

			// 处理标准代码缓存
			if (StandardCode) StandardCode.delSC(guid);

			return 0;

		} else if (result === 1) {
			sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
			return -1;

		} else if (result === 2) {
			sgiLogger.log("提示:参数guid＝" + guid + "已经存在，请更改guid后再保存");
			return -1;

		} else if (result === -1) {
			sgiLogger.log("提示:保存参数异常");
			return -1;

		}
	},
	/**
	 * 发布参数方法
	 * @param {string} guid 要发布的参数guid
	 * @return {number} 0-成功，-1-失败
	 * 
	 * @ignore
	 */
	publish: function (guid, type) {
		if (!guid) return -1;
		if (sgiCommon.getType(guid) === "array") {
			return sgiPfClient.restcall(sgiConfig.pf + "/publish/" + type, "POST", JSON.stringify(guid), { 'Content-Type': "application/json; charset=utf-8" });
		} else {
			return sgiPfClient.restcall(sgiConfig.pf + "/publish/" + guid, "GET");
		}
	},

	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmBySS: function (ap, tt, ss) {
		if (!ap && !tt && !ss) {
			return null;
		}

		if (smProjDndConfig.isSAPrmByAP(ap)) {
			return SAPrmFactory.getPrmDetailBySS(ap, tt, ss);
		}
		var result = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + "ap/" + ap + "/tt/" + tt + "/ss/" + ss, "GET");
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} guid 
	 * 
	 * @ignore
	 */
	getDSDPrmBySS: function (ap, guid) {
		if (!ap) return null;
		var result = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + "ap/" + ap + "/guid/" + guid, "GET");
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 获取指定系统下的参数
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @returns {object[]} 返回符合条件的参数数组
	 */
	getPrmByTT: function (ap, tt) {
		if (!ap && !tt) {
			return null;
		}

		if (smProjDndConfig.isSAPrmByAP(ap)) {
			return SAPrmFactory.getPrmDetailByTT(ap, tt, false);
		}

		var result = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + "ap/" + ap + "/tt/" + tt, "GET");
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 保存资源
	 * @param {object} resource 要保存的资源对象
	 * @return {number} 0-成功，-1-失败
	 * 
	 * @ignore
	 */
	saveResources: function (resource) {

		if (!resource) return -1;

		var ap = resource.ap;
		var tt = resource.tt;
		var ss = resource.ss;
		var te = resource.te;
		if (!ap || !tt || !ss || !te) return -1;

		var vsn = resource.vsn;
		if (vsn) resource.vsn = parseInt(vsn) + 1;//版本管理

		var data = {};
		data.root = sgiCommon.jsonToStr(resource);

		var result = sgiPfClient.restcall(sgiConfig.pf + "/resource/" + resource.sc, "PUT", data);
		if (result == 0) {
			sgiLogger.log("提示:保存成功");
			return 0;
		} else if (result == 1) {
			sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
			return 1;
		} else {
			sgiLogger.log("提示:不等于0不等于0不等于0，请刷新");
			return -1;
		}
	},

	/**
	 * 获取资源
	 * @param {string} sc 资源id
	 * 
	 * @ignore
	 */
	getResource: function (sc) {

		if (!sc) return null;

		var result = sgiPfClient.restcall(sgiConfig.pf + "/resource/" + sc, "GET");
		if (!result) return null;
		return result;
	},

	/**
	 * 获取资源列表，根据ap、tt、ss
	 * @param {string} ap 
	 * @param {string} [tt] 
	 * @param {string} [ss] 
	 * @returns {object[]} 资源对象数组
	 * 
	 * @ignore
	 */
	getResourceList: function (ap, tt, ss) {
		if (!ap && !tt && !ss) {
			return null;
		}
		var condition = { ap: ap, tt: tt, ss: ss };

		var data = {};
		data.root = sgiCommon.jsonToStr(condition);

		var result = sgiPfClient.restcall(sgiConfig.pf + "/resource/list/", "PUT", data);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 查询资源是否存在，存在返回资源对象
	 * @param {string} ap ap
	 * @param {string} tt tt
	 * @param {string} ss ss
	 * @param {string} text 资源文本
	 * @returns {object} 匹配的资源对象
	 * 
	 * @ignore
	 */
	existResource: function (ap, tt, ss, text) {

		// if (!ap && !tt && !ss) return null;

		// if(text) text = "%" + text + "%";

		var condition = { ap: ap, tt: tt, ss: ss, te: text };

		var data = {};
		data.root = sgiCommon.jsonToStr(condition);

		var result = sgiPfClient.restcall(sgiConfig.pf + "/resource/list/", "PUT", data);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}

		if (prms.length >= 1) return prms[0];

		return null;

	},

	/**
	 * 条件查询文本资源
	 * @param {string} ap ap
	 * @param {string} tt tt
	 * @param {string} ss ss
	 * @param {string} text 资源文本
	 * @returns {object[]} 匹配到的资源对象数组
	 * 
	 * @ignore
	 */
	getRsList: function (ap, tt, ss, text) {

		if (!ap && !tt && !ss) return null;

		if (text) text = "%" + text + "%";
		else text = null;//消除空字符串影响

		var condition = { ap: ap, tt: tt, ss: ss, te: text };

		var data = {};
		data.root = sgiCommon.jsonToStr(condition);

		var result = sgiPfClient.restcall(sgiConfig.pf + "/resource/list/", "PUT", data);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 查询参数历史版本
	 * @param {string} guid 参数guid
	 * @return {object[]} 历史版本参数数组
	 */
	getHisPrmsByGuid: function (guid) {

		if (!guid) return;

		var result = sgiPfClient.restcall(sgiConfig.pf + "/history/" + guid, "GET");
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 查询参数历史版本,带分页功能
	 * @param {string} guid 参数guid
	 * @param {object} [params] 分批信息{pageSize:每页记录数,current:当前页号，从0开始}
	 * @return {object[]} 历史版本参数数组
	 */
	getHisPrmsByGuidWithPage: function (guid, params) {

		if (!guid) return;
		params = params || {};

		var data = {};
		var header = {};
		if (params.pageSize) {
			header.pagesize = parseInt(params.pageSize);
		} else {
			header.pagesize = 0;
		}
		if (params.current) {
			header.pageno = params.current;
		} else {
			header.pageno = 0;
		}
		var result = undefined;
		var pagecount = 0;
		var total = 0;
		var success = function (data, textStatus, xhr) {
			result = data;
			pagecount = xhr.getResponseHeader("pagecount");
			total = xhr.getResponseHeader("total");
		}
		sgiPfClient.restcall(sgiConfig.pf + "/history/" + guid, "GET", data, header, false, success);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		var results = {};
		results.list = prms;
		results.pagecount = parseInt(pagecount);
		results.total = parseInt(total);

		return results;
	},


	/**
	 * 模糊查询
	 * @param {string} ap 系统编码
	 * @param {string} tt 顶级类型编码
	 * @param {string} ss 子系统编码
	 * @param {string} condition 参数条件
	 * @returns {object[]} 符合条件的参数列表
	 */
	getPrmsByCondition: function (ap, tt, ss, condition) {
		if (!ap) return null;

		let data = {};
		let result = sgiPfClient.restcall(sgiConfig.pf + "/prm/ap/" + ap + "/tt/" + tt + "/ss/" + ss + "/condition/" + condition, "GET", data);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 替换参数历史版本
	 * @param {object} root 要恢复的历史版本参数
	 * @return {number} 0成功，1失败
	 */
	recover: function (root) {

		if (!root) return;
		let guid = root.guid;
		if (!guid) return;
		let nowPrm = this.getPrm(guid);

		root.prmVsn = nowPrm.prmVsn;

		return this.save(root);
	},

	/**
	 * 根据guid删除指定参数
	 * @param {string} guid 制定guid
	 */
	remove: function (guid) {
		if (!guid) {
			return -1;
		}
		if (typeof guid != 'string' || guid.constructor != String) {
			return -1;
		}
		var ms = guid.split("`");
		var mguid = ms[0];
		var result = sgiPfClient.restcall(sgiConfig.pf + "/prm/" + guid, "DELETE");
		if (result == 0) {
			if (cacheFlag) {
				this.deleteLocal(guid);
			}
		}
		return result;
	},

	/**
	 * 从本地缓存获取参数
	 * @param {string} guid 参数guid
	 * @returns {object} 返回缓存参数
	 * 
	 * @ignore
	 */
	getPrmCache: function (guid) {
		return sgiLocalStorage.get(guid);
	},
	/**
	 * 将参数缓存至本地缓存中
	 * @param {string} guid 参数guid
	 * @param {object} json 参数对象
	 * 
	 * @ignore
	 */
	saveLocal: function (guid, json) {
		sgiLocalStorage.set(guid, json);
	},
	/**
	 * 从本地缓存中删除参数
	 * @param {string} guid 参数guid
	 * 
	 * @ignore
	 */
	deleteLocal: function (guid) {
		sgiLocalStorage.remove(guid);
	},

	/**
	 * 组装guid
	 * @param {object} root 参数对象
	 * @returns {string} 返回的guid
	 * 
	 * @ignore
	 */
	makeGUID: function (root) {
		if (root && root.guid) {
			return root.guid
		}
		var ap, tt, ss, sc;
		ap = root.ap;
		tt = root.tt;
		ss = root.ss;
		sc = root.sc;
		if (!(ap && tt && ss && sc)) {
			return null;
		}
		// var guid = ap + GUID.SP + tt + GUID.SP + ss + GUID.SP + sc;
		var guid = ap + GUID.SP + tt + GUID.SP + sc;
		return guid;
	},
	/**
	 * 在参数对象子节点中寻找sc匹配的子节点对象
	 * @param {object} json 参数对象
	 * @param {string} sc sc
	 * @returns {object} 匹配的子节点参数对象
	 * 
	 * @ignore
	 */
	findMenber: function (json, sc) {
		if (!json) {
			return null;
		}
		var children = json.cldSet;
		if (!children)
			return null;
		var count = children.length;
		for (var i = 0; i < count; i++) {
			if (children[i].sc === sc) {
				json = children[i];
				break;
			}
		}
		return json;
	},

	/**
	 * 创建新的ap
	 * @param {object} application 新的ap对象
	 * @param {*} prmsIn something
	 * @returns {number} 0成功，-1失败
	 * 
	 * @ignore
	 */
	saveApplication: function (application, prmsIn) {

		if (!application || !application.id) return -1;

		var data = {};
		data.root = sgiCommon.jsonToStr(application);
		if (prmsIn) data.prmsIn = sgiCommon.jsonToStr(prmsIn);

		var result = sgiPfClient.restcall(sgiConfig.pf + "/app/" + application.id, "PUT", data);
		if (result == 0) {
			sgiLogger.log("提示:保存成功");
		} else if (result == 1) {
			sgiLogger.log("提示:参数冲突.已经有人修改了该参数，请刷新");
		} else {
			sgiLogger.log("提示:不等于0不等于0不等于0，请刷新");
		}
		return result;
	},

	/**
	 * 获取所有ap列表
	 * @returns {object[]} 所有ap列表
	 */
	getAPList: function () {
		var data = {};
		var result = sgiPfClient.restcall(sgiConfig.pf + "/app/list/", "GET", data);
		var prms = new Array();
		if (result) {
			result = sgiCommon.strToJson(result);
			result.forEach(function (strJson, index) {
				let json = sgiCommon.strToJson(strJson);
				prms.push(json);
			});
		}
		return prms;
	},

	/**
	 * 删除ap
	 * @param {object} application ap参数对象
	 * @returns {number} 0成功，-1失败
	 * 
	 * @ignore
	 */
	deleteApplication: function (application) {

		if (!application || !application.id) return -1;

		var result = sgiPfClient.restcall(sgiConfig.pf + "/app/" + application.id, "DELETE");
		return result;
	},
}

// 初始化
if (!window.PrmFactory) window.PrmFactory = PrmFactory;
// 添加方法
else Object.assign(window.PrmFactory, PrmFactory);
// 导出
let wPrmFactory = window.PrmFactory;
export { wPrmFactory as PrmFactory };
export default wPrmFactory;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/PrmFactory.js